import { render, staticRenderFns } from "./ProductsTableSkeleton.vue?vue&type=template&id=dc874672&scoped=true"
import script from "./ProductsTableSkeleton.vue?vue&type=script&lang=ts"
export * from "./ProductsTableSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./ProductsTableSkeleton.vue?vue&type=style&index=0&id=dc874672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc874672",
  null
  
)

export default component.exports